import { formatCurrency } from '../../utils/currency';
import { TOUCH_TARGET_CLASS } from './styles';

interface InstallmentPickerProps {
  amount: number;
  maxCount: number;
  value: number;
  interestFree: boolean;
  onChange: (count: number) => void;
}

export function InstallmentPicker({ amount, maxCount, value, interestFree, onChange }: InstallmentPickerProps) {
  const options = Array.from({ length: maxCount }, (_, i) => i + 1);

  return (
    <div role="group" aria-label="Parcelamento no cartão de crédito">
      <p className="text-sm font-medium text-text-medium mb-2">
        Parcelamento{interestFree ? ' (sem juros)' : ''}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {options.map((count) => {
          const selected = count === value;
          return (
            <button
              key={count}
              type="button"
              aria-pressed={selected}
              onClick={() => onChange(count)}
              className={[
                `${TOUCH_TARGET_CLASS} border rounded-xl px-3 py-2 text-sm transition-colors`,
                selected
                  ? 'bg-chocolate-dark text-white border-chocolate-dark font-bold'
                  : 'bg-white text-text-medium border-champagne-dark font-medium hover:border-chocolate hover:bg-champagne/30',
              ].join(' ')}
            >
              {count === 1 ? 'À vista' : `${count}x de R$ ${formatCurrency(amount / count)}`}
            </button>
          );
        })}
      </div>
    </div>
  );
}
